import { useAuth } from '@/utils/AuthContext';

// Artifact types blocked for basic tier — none: Basic now includes all tools
const BASIC_BLOCKED_ARTIFACTS: string[] = [];

export function useAiPagePermissions(
  itemCount: number,
  freeLimit: number,
  artifactType?: string,
) {
  const { subscriptionTier, isFree, isUnlimited } = useAuth();
  // Безлимитный аккаунт не подпадает под ограничения basic-тарифа.
  const isBasic = subscriptionTier === 'basic' && !isUnlimited;

  // Basic tier blocks financial model and marketing strategy
  const isBlockedForBasic = isBasic && artifactType
    ? BASIC_BLOCKED_ARTIFACTS.includes(artifactType)
    : false;

  const canCreateNew = (!isFree && !isBlockedForBasic) || itemCount < freeLimit;
  // On the student plan an edit regenerates the artifact in place; the backend
  // enforces the per-artifact edit allowance.
  const canEdit = !isFree && !isBlockedForBasic;
  const canDelete = !isFree;
  return { isFree, isBasic, isBlockedForBasic, canCreateNew, canEdit, canDelete, subscriptionTier };
}
